module.exports = __webpack_public_path__ + "img/25_74.26f81f6b.png";